// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button.availability[data-v-ac8ad810]{margin-bottom:8px}`, "",{"version":3,"sources":["webpack://./src/components/Editor/Resources/ResourceListSearch.vue"],"names":[],"mappings":"AACA,sCACM,iBAAA","sourcesContent":[".button.availability{margin-bottom:8px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
